import { useFormat } from 'helpers/hooks/useFormat';
import ProductFeatureIcon from './ProductFeatureIcon';

type Props = {
  feature: string;
  children: React.ReactNode;
  className?: string;
};

const ProductFeature: React.FC<Props> = ({ feature, children, className }) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });
  return (
    <div className={className}>
      <p className="font-bold">{formatMessage({ id: `feature.${feature}`, defaultMessage: feature })}</p>
      <div className="mt-6 flex items-center gap-6">
        <ProductFeatureIcon feature={feature} className="max-w-20" />
        <div>{children}</div>
      </div>
    </div>
  );
};

export default ProductFeature;
